import { checkNotEmpty } from '../../helpers/validators';
export const validateAddress = ({ value, required }) => {
    return required ? checkNotEmpty({ value, type: 'immediate' }) : null;
};
